import React from 'react';
import { Box, Typography } from '@mui/material';
import carIconImage from '../assets/kariatn.png';

interface CarYaLogoProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  showIcon?: boolean;
  collapsed?: boolean;
}

const CarYaLogo: React.FC<CarYaLogoProps> = ({
  size = 'medium',
  collapsed = false,
  showIcon = true,
  color = '#C86B4A',
}) => {
  const sizes = {
    small: {
      icon: 24,
      fontSize: 20,
      gap: 0.75
    },
    medium: {
      icon: 36,
      fontSize: 32,
      gap: 1.5
    },
    large: {
      icon: 48,
      fontSize: 42,
      gap: 2
    }
  };

  const currentSize = sizes[size];

  if (collapsed) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: 40,
          overflow: 'hidden',
        }}
      >
        <img
          src={carIconImage}
          alt="Karia"
          style={{
            height: currentSize.icon,
            maxWidth: 36,
            objectFit: 'contain',
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: currentSize.gap,
      }}
    >
      {showIcon && (
        <img
          src={carIconImage}
          alt="Karia Icon"
          style={{
            height: currentSize.icon,
            width: 'auto',
            objectFit: 'contain',
          }}
        />
      )}
      <Typography
        sx={{
          fontSize: currentSize.fontSize,
          fontWeight: 700,
          color,
          fontFamily: "'Manrope', sans-serif",
          letterSpacing: '0.5px',
          userSelect: 'none',
          lineHeight: 1,
          textShadow: '1px 1px 2px rgba(0,0,0,0.1)',
        }}
      >
        Karia
      </Typography>
    </Box>
  );
};

export default CarYaLogo;